<template>
  <div>
    <div class="filter-container" v-if="showQuery">
      <slot name="header" />
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="isMB ? 11 : 16">
          <span class="span-top-text">查询条件</span>
          <!-- <el-button
            size="mini"
            :icon="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"
            @click="showForm = !showForm"
            style="margin-left:10px;"
            class="searchIcon"
          />-->
          <div class="searchIcon" @click="showForm = !showForm">
            <i
              :class="showForm ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></i>
          </div>
        </el-col>
        <el-col :span="isMB ? 13 : 8">
          <div class="btn-search" v-if="showSearchBn">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-search"
              @click="query()"
              >搜索</el-button
            >
            <el-button size="mini" type="primary" plain @click="resetQuery"
              >重置</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row v-show="showForm">
        <el-divider style="margin:0px;"></el-divider>
        <el-form class="form-item" @keyup.enter.native="query()">
          <slot name="query"></slot>
        </el-form>
      </el-row>
    </div>
    <slot name="tab" />
    <div
      v-if="showToolbar"
      class="filter-container"
      style="border-bottom: 0;margin-bottom: 0;"
    >
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="10">
          <slot name="toolbar-left">
            <span v-if="showQuery" class="span-top-text">查询结果</span>
          </slot>
        </el-col>
        <el-col :span="14">
          <div style="text-align: right;">
            <slot name="toolbar-right"></slot>
          </div>
        </el-col>
      </el-row>
    </div>
    <slot name="list" :data="data" v-if="showTable">
      <el-table
        ref="table"
        :data="data"
        :size="size"
        :show-header="showHeader"
        highlight-current-row
        :row-key="rowKey"
        :stripe="showStripe"
        :border="border"
        :loading="loading"
        :reserve-selection="reserveSelection"
        @selection-change="onCheckChange"
        :default-expand-all="expandAllRow"
        :expand-row-keys="expands"
        style="width: 100%;margin-bottom: 20px;"
        :row-style="{ height: '40px' }"
        :cell-style="{ padding: '0px' }"
        @sort-change="onSortChange"
        :show-summary="showSummary"
        :summary-method="summaryMethod"
        @cell-click="statusFun"
        @expand-change="expandOpen"
        @row-click="handleRowClick"
      >
        <template v-if="showExpand">
          <!-- <el-table-column type="expand" >
             <slot name="expand" ></slot>
              <template slot-scope="props">
                {{props}}
              </template>
          </el-table-column> -->
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :ref="'expandtable'+props.$index"
                :data="props.row.expand ? props.row.expand : []"
                :loading="loading"
                style="width: 100%"
                size="mini"
              >
                <slot name="expand"></slot>
              </el-table>
            </template>
          </el-table-column>
        </template>
        <template v-if="showCheckbox">
          <el-table-column
            :selectable="noselect"
            type="selection"
            align="center"
            fixed
            width="40"
          />
        </template>
        <el-table-column
          v-if="showTreeSelect"
          type="index"
          align="center"
          width="45"
        >
          <template #header>
            <el-checkbox
              :indeterminate="topInd(topRow)"
              v-model="topRow.Checked"
              @change="handleSelect(topRow)"
            ></el-checkbox>
          </template>
          <template slot-scope="{ row }">
            <el-checkbox
              :indeterminate="rowInd(row)"
              v-model="row.Checked"
              @change="handleSelect(row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="table"></slot>
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </el-table>
    </slot>

    <div v-if="isSumData">
      <span style="padding-right:20px" v-if="sumData">金额总合计：{{$commonJs.toThousands(sumData)}}</span>   
      <span v-if="sumQuantity">数量总合计：{{$commonJs.toThousands(sumQuantity)}}</span>
      <span style="padding-right:20px" v-if="sumIncome">收入总合计：{{$commonJs.toThousands(sumIncome)}}</span>   
      <span v-if="sumPay">支出总合计：{{$commonJs.toThousands(sumPay)}}</span>
    </div>
    <!-- 分页 -->
    <el-pagination
      v-if="page"
      style="margin-top: 5px;"
      :page-size.sync="pageParams.pageSize"
      :current-page.sync="pageParams.pageIndex"
      :layout="isMB ? MBpageLayout : pageLayout"
      :page-sizes="pageSizes"
      :total="listTotal"
      @size-change="onPageSizeChange"
      @current-change="onPageIndexChange"
    />
  </div>
</template>
<script>
export default {
  props: {
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40, 100]
    },
    isSumData: {
      type: Boolean,
      default: false,
    },
    reRowClick: {
      type: Boolean,
      default: false,
    },
    reserveSelection: {
      type: Boolean,
      default: false,
    },
    /** getRowClickFunc 属性介绍
     ** 重置行点击事件
     */
    getRowClickFunc: {
      type: Function,
      default: null,
    },
    showSearchBn: {
      type: Boolean,
      default: true,
    },
    showTable: {
      type: Boolean,
      default: true,
    },
    rowKey: {
      type: String,
      default: undefined,
    },
    showStripe: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    showHeader: { type: Boolean, default: true },
    showQuery: {
      type: Boolean,
      default: false,
    },
    showToolbar: {
      type: Boolean,
      default: true,
    },
    expandAllRow: {
      type: Boolean,
      default: false,
    },
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    showExpand: {
      type: Boolean,
      default: false,
    },
    //判断复选框是否禁用的条件语句
    condition: {
      type: String,
      default: "true",
    },
    showTreeSelect: {
      type: Boolean,
      default: false,
    },
    isTree: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "medium",
    },
    unit: {
      type: String,
      default: "记录",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    queryParams: {
      type: Object,
      defalut: () => ({}),
    },
    localDelete: {
      type: Boolean,
      default: false,
    },
    deleteConfirmText: {
      type: String,
      default: undefined,
    },
    confirmOnDelete: {
      type: Boolean,
      default: true,
    },
    deleteHelpMessage: {
      type: String,
      default: "",
    },
    page: {
      type: Boolean,
      default: true,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      type: Function,
      default: () => {},
    },
    /** getDataFunc 属性介绍
     ** 接收一个查询条件的json对象，然后返回promise的函数，resolve的数据必须有一个字段为data的数组，如下
     ** 注：此属性如果有设置，则getListFunc、getPageListFunc、getPageListWithSummaryFunc函数都不起效
     ** getDataFunc = (params) => {
     **   return new Promise((resolve, reject) => {
     **     //无分页时
     **     resolve({
     **       data: []
     **     });
     **      //有分页时
     **     resolve({
     **       data: {list:[],total:0}
     **     });
     **   });
     ** };
     **/
    getDataFunc: {
      type: Function,
      default: null,
    },

    /** deleteFunc 属性介绍
     ** 接收一个id值，返回promise的函数，resolve的数据，reject最好有一个message字段，如下
     ** deleteFunc = (id) => {
     **   return new Promise((resolve, reject) => {
     **     //成功时
     **     resolve();
     **
     **     //失败时
     **     reject({
     **       message:"删除失败！"
     **     })
     **   });
     ** };
     */
    deleteFunc: {
      type: Function,
      default: null,
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    pageSize: {
      type: Number,
      default: undefined,
    },
    unitList: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      data: [],
      sourceData: [],
      expands: [],
      total: 0,
      loading: false,
      checkedRows: [],
      showForm: true,
      initParams: {},
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: 1,
      },
      //查询参数
      tempQueryParams: {},
      initQueryParams: {},
      orderParams: {
        SortName: "", //排序字段
        SortOrder: "", //排序顺序 降序：desc 升序：asc
      },
      isMB: this.$store.state.isMB,
      MBpageLayout: "total, sizes, prev, pager, next",
      sumData: '',
      sumQuantity:"",
      sumIncome: '',
      sumPay:"",
    };
  },
  mounted() {
    this.initQueryParams = { ...this.queryParams };
    this.tempQueryParams = { ...this.queryParams };
  },
  computed: {
    listTotal() {
      if (this.page) {
        return this.total;
      }
      return this.data.length;
    },
    topRow() {
      return {
        Checked: false,
        children: this.data,
      };
    },
  },
  methods: {
    handleRowClick(row, column, e) {
      this.$emit("row-select", row);
      if (this.reRowClick) {
        //
        if (column == null || column.label === "操作" || column.label === "") {
          //
        } else {
          this.getRowClickFunc(row, column, e);
          this.$refs.table.toggleRowExpansion(row);
        }
      } else {
        if (column == null || column.label === "操作") {
          //
        } else {
          this.$refs.table.toggleRowExpansion(row);
        }
      }
    },
    getexpand() {
      this.data = this.unitList(this.data);
    },
    setExpands(data) {
      this.expands = data;
      
    },
    // tableRowClassName({ row, rowIndex }) {
    //   
    //   return this.rowClassNameFunc({ row, rowIndex });
    // },
    onCheckChange(valueArrary) {
      this.checkedRows = valueArrary;
      this.$emit("check-change", valueArrary);
    },
    statusFun(row, column, cell, event) {
      // 
      this.$emit("status-change", row, column);
    },
    expandOpen(row, column, cell, event) {
      // 
      this.$emit("expand-change", row, column);
    },
    //重新排列表格
    setLayout() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    //获取选中的行
    getCheckedRows() {
      if (this.showTreeSelect) return this.sourceData.filter((x) => x.Checked);
      else return this.checkedRows;
    },
    //复选框禁用
    noselect(row, index) {
      return eval(this.condition);
    },
    //查询方法
    query(params = null) {
      if (params != null) {
        
        for (let key in params) {
          this.queryParams[key] = params[key];
        }
      }
      
      this.tempQueryParams = { ...this.queryParams };
      this.pageParams.pageIndex = 1;
      return this.getData();
    },
    //重置查询条件
    resetQuery() {
      for (let key in this.queryParams) {
        this.queryParams[key] = this.initQueryParams[key];
      }
      // 
      this.$emit("reset-query");
      return this.query();
    },
    onSortChange({ prop, order }) {
      // 
      this.orderParams.SortOrder =
        order == "descending" ? "desc" : order == "ascending" ? "asc" : "";
      this.orderParams.SortName = order == null ? null : prop;
      this.getData();
    },
    getData(initParams = null) {
      if (initParams != null) {
        this.clear();
        this.initParams = { ...initParams };
        return this.resetQuery();
      }
      let params = {};
      if (this.page) {
        params = { ...this.pageParams };
      }
      params = {
        ...params,
        ...this.tempQueryParams,
        ...this.initParams,
        ...this.orderParams,
      };
      params = this.$commonJs.obj.removeNullKey(params);
      this.loading = true;

      let getDataFunc = null;
      
      if (this.getDataFunc) {
        getDataFunc = this.getDataFunc;
      } else {
        alert("请指定list组件里get-data-func属性！");
        return false;
      }
      return new Promise((resolve, reject) => {
        getDataFunc(params)
          .then((res) => {
            if (res.Code == 0) {
              if (!this.disabled) {
                if (res.Data instanceof Array) {
                  if (this.showTreeSelect) {
                    res.Data = res.Data.map((x) => {
                      return { ...x, Checked: false };
                    });
                    this.sourceData = res.Data;
                  }
                  if (this.isTree) {
                    res.Data = this.$commonJs.toTreeData(res.Data, this.rowKey);
                  }
                  
                  this.data = res.Data;
      
                  if(this.isSumData){
                    console.log(res.Msg)
                    let sumModel=JSON.parse(res.Msg)
                    this.sumData = sumModel.TotalAmount
                    this.sumQuantity=sumModel.TotalQuantity
                    this.sumPay = sumModel.TotalPay
                    this.sumIncome =sumModel.TotalIncome
                  }
                  
                  if (this.page) {
                    this.total = res.Count;
                  } else {
                    this.total = res.Data.length;
                  }
                } else {
                  alert("找不到数据列表，请在data字段或者data.list字段赋值！");
                }
              } else {
                this.$commonJs.showMessage("未授权");
              }
            }
            this.hasGetData = true;
            this.loading = false;
            resolve({ list: this.data, total: this.total });
          })
          .catch((err) => {
            
            reject(err);
          });
      });
     
    },
    _delete(func, data, rows, message) {
      return new Promise((resolve, reject) => {
        let promise;
        if (this.confirmOnDelete) {
          promise = this.$confirm(message, "删除确认", {
            type: "warning",
          });
        } else {
          promise = Promise.resolve();
        }
        return promise
          .then(() => {
            this.loading = true;
            func(data)
              .then((res) => {
                
                if (res.Code != undefined && res.Code != 0) {
                  this.$message.warning(res.Msg);
                  this.loading = false;
                  return;
                }
                if (this.page) {
                  this.getData();
                } else {
                  if (!(rows instanceof Array)) {
                    rows = [rows];
                  }
                  rows.forEach((item) => {
                    let rowIndex = this.data.indexOf(item);
                    if (rowIndex > -1) {
                      this.data.splice(rowIndex, 1);
                    }
                  });
                  this.loading = false;
                }
                this.$emit("deleted");
                if (this.confirmOnDelete) {
                  this.$message.success("删除成功");
                }
                resolve(res);
              })
              .catch((err) => {
                this.loading = false;
                reject(err);
              });
          })
          .catch((res) => {});
      });
    },
    delete(row = null) {
      // row = row || this.getCheckedRowWithMessage();
      if (!row) {
        return false;
      }
      let deleteFunc;
      if (this.localDelete) {
        deleteFunc = Promise.resolve();
      } else {
        if (!this.deleteFunc) {
          alert("请在list组件中指定delete-func属性");
          return false;
        } else {
          deleteFunc = this.deleteFunc;
        }
      }

      let text =
        "您确定要删除这个" + this.unit + "吗？" + this.deleteHelpMessage;
      if (this.deleteConfirmText) {
        text = this.deleteConfirmText;
      }
      return this._delete(deleteFunc, row[this.rowKey], [row], text);
    },
    reload() {
      return this.getData();
    },
    clear() {
      this.total = 0;
      this.data = [];
    },
    //分页容量大小发生变化时
    onPageSizeChange(value) {
      // this.pageParams.pageSize = value;
      this.getData();
    },
    //
    onPageIndexChange(pageIndex) {
      // this.pageParams.currentPage = pageIndex;
      this.getData();
    },
    getTreeSelectRows() {
      let checkedRow = this.sourceData.filter((item) => item.Checked == true);
      return checkedRow;
    },
    handleSelect(row) {
      if (row.Pid != undefined && row.Pid != 0) {
        this.setParent(row.Pid);
      }
      if (row.children) {
        this.setChild(row.children, row.Checked);
      }
    },
    setParent(pid) {
      let parent = this.sourceData.find((item) => item.DpId == pid);
      if (parent) {
        parent.Checked = parent.children.every((s) => s.Checked);
        if (parent.Pid != 0) {
          this.setParent(parent.Pid);
        }
      }
    },
    setChild(data, value) {
      data.forEach((item) => {
        item.Checked = value;
        if (item.children) {
          this.setChild(item.children, value);
        }
      });
    },
    topInd(row) {
      if (this.sourceData.every((item) => item.Checked)) {
        row.Checked = true;
        return false;
      } else {
        row.Checked = false;
        if (this.sourceData.some((item) => item.Checked)) {
          return true;
        } else {
          return false;
        }
      }
    },
    rowInd(item) {
      if (item.children) {
        if (item.children.every((o) => o.Checked)) {
          return false;
        } else {
          if (item.children.some((o) => o.Checked)) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
.searchIcon {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #aaa;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  margin-left: 4px;
  &:hover {
    cursor: pointer;
    color: #fff;
    background: #409eff;
  }
  i {
    transition-duration: 0.2s;
  }
  .el-icon-arrow-down {
    vertical-align: -1px;
  }
}
</style>
